// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._component-icon-plus[data-v-5e1f0162] {\n  width: 20px;\n  height: 20px;\n}\n._component-icon-plus path[data-v-5e1f0162] {\n  fill: inherit;\n}\n", ""]);
// Exports
module.exports = exports;
